/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchPortfolioContentDetails, fetchSubmissionDetails } from "../../../../Services/redux/Application-details/ApplicationDetailsActions";
import { fetchApplicationDetails } from "../../../../Services/redux/appId-details/AppIdDeatilsActions";
import APIManager from "../../../../Services/ApiManager/ApiManager";
import "./info.css";
import FormControlComp from "./FormControlComp";
import {
  Container,
  Grid2,
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Autocomplete,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Topheader from "../../../../Layout/header/header";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ApplicationDetailsSideMenu from "../../../../Components/ApplicationDetailsSideMenu/ApplicationDetailsSideMenu";
import PopupDialog from "../../../../Components/PopupDialog";
import CloseIcon from "@mui/icons-material/Close";
import { getConfig } from "../../../../config";

const PublishInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisherData, setPublisherData] = useState({});
  const [publisherInfoDataGlobalAdmin, setPublisherInfoDataGlobalAdmin] =
    useState([]);
  const [componentName, setComponentName] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [openReassignPopup, setOpenReassignPopup] = useState(false);
  const [reassignToEmail, setReassignToEmail] = useState("");
  const [payloadId, setPayloadId] = useState("");
  const [searchOptions, setSearchOptions] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(false);

  const { appId, submissionId } = useParams();

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "oem-admin") {
      dispatch(
        fetchPortfolioContentDetails(
          sessionStorage.getItem("portfolioId"),
          sessionStorage.getItem("contentId")
        )
      );
    }
  }, []);
  const submissionDetails = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const appStatus = submissionDetails.status;
  const PaymentID = appData.createdBy;
  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      dispatch(fetchApplicationDetails(appId));
    }
  }, [appId, dispatch]);

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      dispatch(fetchSubmissionDetails(appId, submissionId));
    }
  }, [dispatch, appId, submissionId]);

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      if (submissionDetails && Object.keys(submissionDetails).length > 0) {
        APIManager.getAllApplication(appStatus)
          .catch((error) => {
            console.error("Error fetching data:", error);
            setComponentName("appError");
            setErrorMessage(error.message);
            setHeaderMessage(
              error.message === "jwt expired" ? "401 Token Expired" : "Error"
            );
            setOpenErrorPopup(true);
          });
      }
    }
  }, [appStatus]);

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      if (submissionDetails && Object.keys(submissionDetails).length > 0) {
        setLoader(true);
        APIManager.getGlobalAdminPublisherInfoCognito(PaymentID)
          .then((response) => {
            setPublisherInfoDataGlobalAdmin(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setComponentName("appError");
            setErrorMessage(error.message);
            setHeaderMessage(
              error.message === "jwt expired" ? "401 Token Expired" : "Error"
            );

            setOpenErrorPopup(true);
          })
          .finally(() => {
            setLoader(false);
          });
      }
    }
  }, [PaymentID, appData]);

  useEffect(() => {
    if (getConfig().REACT_APP_PORTAL === "oem-admin") {
      if (submissionDetails && Object.keys(submissionDetails).length > 0) {
        const publiserData = {
          publisherName: submissionDetails.seller.contactFirstName,
          username: submissionDetails.seller.contactFirstName,
          email: submissionDetails.seller.email,
          phone: submissionDetails.seller.phone,
          registrationNumber: "123456",
          country: "India",
          company: "Harman",
          companyLink: submissionDetails.seller.websiteURL,
        };
        setPublisherData(publiserData);
      }
    } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
      if (
        publisherInfoDataGlobalAdmin &&
        Object.keys(publisherInfoDataGlobalAdmin).length > 0
      ) {
        const publiserData = {
          publisherName: publisherInfoDataGlobalAdmin.results[0].firstName,
          eMail: publisherInfoDataGlobalAdmin.results[0].email,
          website: publisherInfoDataGlobalAdmin.results[0].companyWebsite,
        };
        setPublisherData(publiserData);
      }
    }
  }, [submissionDetails, publisherInfoDataGlobalAdmin]);

  const backToApplications = () => {
    if (getConfig().REACT_APP_PORTAL === "seller") {
      navigate(`/ui/developer/applications/${appId}`, {
        state: {
          teamId: sessionStorage.getItem("teamId"),
          submissionId: submissionId,
        },
      });
    } else if (getConfig().REACT_APP_PORTAL === "domain-approver") {
      navigate(
        `/ui/domain-approver/applications/${appId}/submission/${submissionId}`
      );
    } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
      navigate(
        `/ui/harman-admin/application/${appId}/submission/${submissionId}`
      );
    } else if (getConfig().REACT_APP_PORTAL === "oem-admin") {
      navigate("/ui/oem-admin/applications");
    }
  };
  const titles =
    getConfig().REACT_APP_PORTAL === "oem-admin"
      ? {
          publisherName: "Publisher Name",
          username: "Username",
          email: "Email",
          phone: "Phone No.",
          registrationNumber: "Registration Number",
          country: "Country",
          company: "Company",
          companyLink: "Company Link",
        }
      : {
          publisherName: "Publisher Name",
          eMail: "Email",
          website: "Website",
        };

  const searchEmailUsers = async (searchTerm) => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      if (!searchTerm || searchTerm.length < 1) {
        setSearchOptions([]);
        return;
      }

      const payload = {
        roles: ["IGNITESTORESELLER_ROLE"],
        userName: searchTerm,
      };

      APIManager.postFilterReassignOwnership(
        0,
        10,
        "USER_NAMES",
        "ASC",
        true,
        "CONTAINS",
        payload
      )
        .then((response) => {
          let options = [];
          if (response !== null) {
            options = response.results.map((user) => ({
              label: `${user.userName}`,
              value: user.userName,
              firstName: user.firstName,
              id: user.id,
            }));
          }
          setSearchOptions(options);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setComponentName("appError");
          setErrorMessage(error.message);
          setHeaderMessage(
            error.message === "jwt expired" ? "401 Token Expired" : "Error"
          );
          setOpenErrorPopup(true);
          setSearchOptions([]);
        })
    }
  };

  const handleReassignClick = () => {
    setOpenReassignPopup(true);
  };

  const handleReassignClose = () => {
    setOpenReassignPopup(false);
    setReassignToEmail("");
  };

  const handleReassignSubmit = () => {
    if (getConfig().REACT_APP_PORTAL === "global-admin") {
      setLoader(true);
      APIManager.postSubmitReassignOwnership(appId, payloadId)
        .then(() => {
          return dispatch(fetchApplicationDetails(appId));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setComponentName("appError");
          setErrorMessage(error.message);
          setHeaderMessage(
            error.message === "jwt expired" ? "401 Token Expired" : "Error"
          );
          setOpenErrorPopup(true);
          setLoader(false);
          setSearchOptions([]);
        });
      setOpenReassignPopup(false);
      setReassignToEmail("");
      setPayloadId("");
    }
  };
  useEffect(() => {
    const isValid = searchOptions.some(
      (option) => option.value === reassignToEmail
    );
    setEnableSubmit(isValid);
  }, [searchOptions, reassignToEmail]);

  return (
    <>
      <Topheader />
      {loader && (
        <Backdrop
          open={loader}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Container
        maxWidth="lg"
        sx={
          getConfig().REACT_APP_PORTAL === "global-admin"
            ? { width: "100% !important", maxWidth: "100% !important" }
            : {}
        }
      >
        <Grid2 container>
          <Grid2 size={12}>
            <div
              className={
                getConfig().REACT_APP_PORTAL === "global-admin"
                  ? "container-my-release"
                  : "container"
              }
            >
              <div
                className={
                  getConfig().REACT_APP_PORTAL === "global-admin"
                    ? "side-menu-my-release"
                    : "side-menu"
                }
                style={{ marginTop: "69px" }}
              >
                <button
                  className="arrow-back"
                  onClick={backToApplications}
                  style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", padding: 0 }}
                >
                  <ArrowBackIcon style={{ color: "#717273" }} />
                  <div className="my-apps">
                    {getConfig().REACT_APP_PORTAL === "oem-admin"
                      ? "All Apps"
                      : "Back To Applications"}
                  </div>
                </button>

                {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                  submissionDetails &&
                  Object.keys(submissionDetails).length > 0 && (
                    <ApplicationDetailsSideMenu
                      submissionData={submissionDetails}
                    />
                  )}
                {getConfig().REACT_APP_PORTAL === "global-admin" &&
                  appData &&
                  Object.keys(appData).length > 0 && (
                    <ApplicationDetailsSideMenu appData={appData} />
                  )}
              </div>

              <div
                className={
                  getConfig().REACT_APP_PORTAL === "global-admin"
                    ? "submission-container-all-release"
                    : "publisherInfo"
                }
                style={
                  getConfig().REACT_APP_PORTAL === "global-admin"
                    ? { width: "70%", marginLeft: "22%" }
                    : {}
                }
              >
                <div className="publisherInfoHeader">
                  <p className="heading">Publisher Info</p>

                  {getConfig().REACT_APP_PORTAL === "global-admin" && (
                    <div className="re-assign-ownership">
                      <button
                        className="re-assign-ownership-btn"
                        onClick={handleReassignClick}
                      >
                        Re-Assign Ownership
                      </button>
                    </div>
                  )}
                </div>

                <div className="divForm">
                  <form className="publisherForm">
                    {Object.entries(publisherData).map(([key, value]) => {
                      return (
                        <FormControlComp key={key} title={titles[key]} value={value} />
                      );
                    })}
                  </form>
                </div>
              </div>
            </div>
          </Grid2>
        </Grid2>
      </Container>

      {/* Re-assign Ownership Popup */}
      <Modal
        open={openReassignPopup}
        onClose={handleReassignClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: 24,
            p: 0,
            minWidth: "400px",
            maxWidth: "500px",
            outline: "none",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 3,
              pb: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "600",
                fontSize: "20px",
                color: "#2A2C2D",
              }}
            >
              {appData.name}
            </Typography>
            <IconButton
              onClick={handleReassignClose}
              sx={{
                p: 0,
                color: "#666",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box sx={{ px: 3, pb: 3 }}>
            {/* From Section */}
            <Typography
              sx={{
                fontSize: "16px",
                mb: 1,
                color: "#2A2C2D",
              }}
            >
              Re-assign listing ownership from:
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                mb: 2,
                color: "#2A2C2D",
              }}
            >
              {publisherData?.eMail || "N/A"} (
              {publisherData?.publisherName || "N/A"})
            </Typography>

            {/* To Section */}
            <Typography
              sx={{
                fontSize: "16px",
                mb: 1,
                color: "#2A2C2D",
              }}
            >
              To:
            </Typography>
            <Autocomplete
              freeSolo
              options={searchOptions}
              getOptionLabel={(option) => {
                if (typeof option === "string") {
                  return option;
                }
                return option.label || "";
              }}
              renderOption={(props, option) => (
                <Box component="li" {...props}>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {option.value}
                    </Typography>
                    {option.firstName && (
                      <Typography variant="caption" color="text.secondary">
                        First Name: {option.firstName}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
              inputValue={reassignToEmail}
              onInputChange={(event, newInputValue) => {
                setReassignToEmail(newInputValue);
                if (newInputValue && newInputValue.trim().length >= 1) {
                  searchEmailUsers(newInputValue.trim());
                } else {
                  setSearchOptions([]);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  if (typeof newValue === "string") {
                    setReassignToEmail(newValue);
                  } else setReassignToEmail(newValue.value);
                  setPayloadId(newValue.id);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="User"
                  variant="outlined"
                  sx={{
                    mb: 3,
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#0476E2",
                      },
                      "&:hover fieldset": {
                        borderColor: "#0476E2",
                      },
                    },
                  }}
                />
              )}
              loading={loader}
              loadingText="Searching users..."
              noOptionsText={
                reassignToEmail.length < 1
                  ? "Type at least 1 character"
                  : "No users found"
              }
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: "200px",
                },
                "& .MuiAutocomplete-option": {
                  padding: "12px 16px",
                },
              }}
            />

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Button
                onClick={handleReassignClose}
                disabled={loader} // Disable when loading
                sx={{
                  color: "#666",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    border: "1px solid #ccc",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleReassignSubmit}
                disabled={!enableSubmit || reassignToEmail.length < 1 || loader} // Add loader to disabled condition
                sx={{
                  backgroundColor:
                    !enableSubmit || reassignToEmail.length < 1 || loader
                      ? "#ccc"
                      : "#0476E2",
                  color: "white",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                  opacity:
                    !enableSubmit || reassignToEmail.length < 1 || loader
                      ? 0.6
                      : 1,
                  "&:hover": {
                    backgroundColor:
                      !enableSubmit || reassignToEmail.length < 1 || loader
                        ? "#ccc"
                        : "#0361C4",
                  },
                  "&:disabled": {
                    color: "white",
                    backgroundColor: "#ccc",
                  },
                }}
              >
                {loader ? "Processing..." : "Submit"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={() => setOpenErrorPopup(false)}
      />
    </>
  );
};

export default PublishInfo;
